import { Instagram, Youtube, Linkedin, MessageCircle, Mail } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const navLinks = [
    { name: "Beranda", href: "#hero" },
    { name: "Artikel", href: "/news", isRoute: true },
    { name: "Kontak", href: "#contact" },
  ];

  const socialLinks = [
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Youtube, href: "#", label: "YouTube" },
    { icon: Linkedin, href: "#", label: "LinkedIn" },
  ];

  return (
    <footer id="contact" className="bg-slate-950 text-slate-200 relative overflow-hidden py-16">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-[300px] h-[300px] bg-secondary/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <span className="text-2xl font-extrabold tracking-tight text-white block mb-4">
              MindfulMe
            </span>
            <p className="text-slate-400 mb-8 max-w-md text-sm leading-relaxed">
              MindfulMe adalah platform kesehatan mental terpadu di Indonesia yang menghadirkan
              pendampingan psikologis dan bantuan hukum bagi mereka yang membutuhkan ruang aman
              untuk bersuara tanpa stigma.
            </p>
            <div className="flex space-x-3.5">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:bg-primary/20 hover:border-primary/40 hover:text-white hover:scale-110 shadow-md transition-all duration-300"
                    aria-label={social.label}
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-white mb-5 text-sm tracking-wider uppercase">Navigasi</h3>
            <div className="space-y-3.5">
              {navLinks.map((link) =>
                link.isRoute ? (
                  <Link
                    key={link.name}
                    to={link.href}
                    className="block text-slate-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                ) : (
                  <a
                    key={link.name}
                    href={isHome ? link.href : `/${link.href}`}
                    className="block text-slate-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-white mb-5 text-sm tracking-wider uppercase">Kontak</h3>
            <div className="space-y-4 text-slate-400">
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/10 transition-colors">
                  <Mail className="w-4 h-4 text-slate-300 group-hover:text-primary transition-colors" />
                </div>
                <a
                  href="mailto:hello@mindfulme.pusatandalan.com"
                  className="hover:text-white transition-colors duration-200 text-sm truncate"
                >
                  hello@mindfulme.pusatandalan.com
                </a>
              </div>

              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary/10 transition-colors">
                  <MessageCircle className="w-4 h-4 text-slate-300 group-hover:text-secondary transition-colors" />
                </div>
                <a
                  href="https://wa.me/6281936021089"
                  className="hover:text-white transition-colors duration-200 text-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +62 819-3602-1089
                </a>
              </div>

              <p className="text-slate-500 text-xs font-semibold uppercase tracking-widest pl-1">Support 24/7</p>
            </div>
          </div>
        </div>

        {/* Fading Divider */}
        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-slate-800 to-transparent my-10"></div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-slate-500 text-xs">
          <p className="mb-4 md:mb-0">
            © 2025 MindfulMe. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="hover:text-slate-300 transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors duration-200">
              Cookies Settings
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;